import API from 'utils/api';
import getFormattedValues, { hasFiles } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/catalogos/detalle-tarifa-isr';

const getValuesAndConfig = (values) => {
  const config = hasFiles(values) ? {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  } : {};
  const formattedValues = getFormattedValues(values, {
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

/**
 * GET Detalle Tarifas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDetalleTarifas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Detalle Tarifa
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getDetalleTarifa = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Detalle Tarifa
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postDetalleTarifa = async (values) => {
  try {
    const response = await API.post(baseURI, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Detalle Tarifa
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchDetalleTarifa = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, ...getValuesAndConfig(values));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Detalle Tarifa
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteDetalleTarifa = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
